import React from 'react';
import { Box, Typography } from '@mui/material';
import imgMark from 'src/assets/images/templates/t4/title-mark.svg';
import useRTL from 'src/hooks/useRTL';
import { textVariant, textClasses } from '../../shared/config';
import { useCompanyData } from '../../shared/contexts/DataContext';

function SectionTitle({ children, ...props }){
  const [, isRTL,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");
  const { contentSection=false } = props || {};

  const { data } = useCompanyData();
  const { generalTitleFontSize, generalTitleColor } = data || {};
  const titleFontColor = props.color ? props.color : generalTitleColor ? generalTitleColor : '#000';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  return (
    <Box
      pb={3}
      {...(!contentSection ? {pl:2} : {})}
      display="flex"
      alignItems="center"
      overflow="visible"
      style={{
        ...(!contentSection ?
        {
          background: !contentSection ? `url(${imgMark}) no-repeat ${isRTL ? 'right' : 'left'} 5px` : '',
          backgroundSize: '34px 34px',
        }
        :{}),
        fontFamily:fontFamily
      }}
      color={titleFontColor}
      {...props}
    >
      <Typography
        variant={variant}
        className={fontSizeCls}
        style={{ textTransform: 'uppercase' }}
      >
        {children}
      </Typography>
    </Box>
  );
};

function SectionSubtitle({ children, ...props }) {
  const [, ,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");

  const { data } = useCompanyData();
  const { generalSubTitleFontSize, generalSubTitleColor } = data || {};
  const subTitleFontColor = props.color ? props.color : generalSubTitleColor ? generalSubTitleColor : '#000';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18'];

  return (
    <Box
      color={subTitleFontColor}
      {...props}
      style={{fontFamily:fontFamily}}
      >
      <Typography
        variant={variant}
        className={fontSizeCls}
        // color="inherit"
      >
        {children}
      </Typography>
    </Box>
  );
};

function SectionParagraph({ children, ...props }) {
  const [, ,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");

  const { data } = useCompanyData();
  const { generalParagraphFontSize, generalParagraphColor } = data || {};
  const descFontColor = props.color ? props.color : generalParagraphColor ? generalParagraphColor : '#000';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalParagraphFontSize && textVariant?.[generalParagraphFontSize] ? textVariant?.[generalParagraphFontSize] : textVariant?.['16'];
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalParagraphFontSize && textClasses?.[generalParagraphFontSize] ? textClasses?.[generalParagraphFontSize] : textClasses?.['16'];

  return (
    <Box
      color={descFontColor}
      {...props}
      >
      <Typography 
        variant={variant}
        className={fontSizeCls}
        style={{fontFamily}}
        dangerouslySetInnerHTML={props.description}
      />
      </Box>
  );
};

export {
  SectionTitle,
  SectionSubtitle,
  SectionParagraph
};

// export default SectionTitle;
